import React from 'react';
import SearchBarComponent from './SearchBarComponent';
import createReactComponent from '../ReactComponentMaker';
import { blockCategories } from '../categories';

export default (editor) => {
    createReactComponent(editor, {
        type: 'search-bar-component',
        name: 'Suchleiste',
        label: 'Suchleiste',
        category: blockCategories.advance,
        traits: [
            {
                type: 'checkbox',
                name: 'hideCalendarField',
                label: 'Datumsfeld ausblenden',

            },
            {
                type: 'checkbox',
                name: 'hideParticipantField',
                label: 'Teilnehmerfeld ausblenden',

            },
            {
                type: 'checkbox',
                name: 'hideDestinationField',
                label: 'Zielfeld ausblenden',

            },
        ],
        renderComponent: (attributes) => (
            <SearchBarComponent traits={attributes} />
        ),
        media:
            `<svg xmlns="http://www.w3.org/2000/svg" width="50" height="40" viewBox="0 0 200 40">
            <rect x="1" y="1" width="198" height="38" rx="20" ry="20" fill="#fff" stroke="#ccc" stroke-width="2"/>
            <circle cx="30" cy="20" r="8" stroke="#888" stroke-width="2" fill="none"/>
            <line x1="36" y1="26" x2="42" y2="32" stroke="#888" stroke-width="2" stroke-linecap="round"/>
            <text x="60" y="25" font-size="14" fill="#aaa" font-family="Arial, sans-serif">Search...</text>
            </svg>`,
    });
};
